
import { Vue, Prop, Component } from "vue-property-decorator";
import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import { Contractor, Project } from "@/generated/graphql";
import CardBodyItem from "@/components/card/CardBodyItem.vue";
import S3Image from "@/components/common/s3-image.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";

@Component({
    components: {
        SchedulerItemAvatar,
        CircleWithInitials,
        CardBodyItem,
        S3Image,
        PlusIcon,
    },
})

export default class ProjectHoverCard extends Vue {
    @Prop({ type: Object, default: null }) readonly project!: Project;
    @Prop({ type: Boolean, default: false }) readonly flowUp!: boolean;

    flowDirection: string = this.flowUp ? " -mt-36 ml-20" : " mt-15 ml-9";

    get managerFullname(): string {
        const user = this.project.manager.user;
        return (user.given_name ? user.given_name + " " : "") + (user.family_name ? user.family_name : "");
    }

    get contractors(): Contractor[] {
        let contractors: Contractor[] = [];
        this.project.project_activities.forEach(project_activity => {
            contractors.push(project_activity.contractor);
        })
        return contractors;
    }

    get min_budget(): string {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        });
        return formatter.format(this.project.min_budget);
    }

    get max_budget(): string {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        });
        return formatter.format(this.project.max_budget);
    }
}
